import { isUUID } from '@vrplatform/utils';

type OwnerAccessWhere = {
  userId: {
    _eq: string | null | undefined;
  };
  _or?: [
    {
      contact: {
        tenantId: {
          _eq: string;
        };
      };
    },
    {
      owner: {
        tenantId: {
          _eq: string;
        };
      };
    },
  ];
};

export function isOwnerPortalImpersonating({
  isUserPreview,
  queryTeamId,
}: {
  isUserPreview: boolean;
  queryTeamId: string | null;
}) {
  return isUserPreview || (!!queryTeamId && isUUID(queryTeamId));
}

export function isOwnerPortalTeamSwitchPending({
  isImpersonating,
  queryTeamId,
  activeTeamId,
}: {
  isImpersonating: boolean;
  queryTeamId: string | null;
  activeTeamId: string | null | undefined;
}) {
  if (!isImpersonating || !queryTeamId || !isUUID(queryTeamId)) {
    return false;
  }

  return queryTeamId !== activeTeamId;
}

export function isGlOwnerPortalPreview({
  isGL,
  isUserPreview,
}: {
  isGL: boolean;
  isUserPreview: boolean;
}) {
  return isGL && isUserPreview;
}

export function canAccessOwnerPortalSettings({
  isGL,
  isUserPreview,
}: {
  isGL: boolean;
  isUserPreview: boolean;
}) {
  return !isUserPreview || isGlOwnerPortalPreview({ isGL, isUserPreview });
}

export function canAccessOwnerPortalGeneralSettings({
  hasAdminAccess,
  isGL,
  isUserPreview,
}: {
  hasAdminAccess: boolean;
  isGL: boolean;
  isUserPreview: boolean;
}) {
  return hasAdminAccess || isGlOwnerPortalPreview({ isGL, isUserPreview });
}

export function canAccessOwnerPortalPayments({
  isAchEnabled,
  isGL,
  isOwnerArchived,
}: {
  isAchEnabled: boolean;
  isGL: boolean;
  isOwnerArchived: boolean | undefined;
}) {
  return isAchEnabled && isGL && isOwnerArchived === false;
}

export function canShowOwnerPortalDashboard({
  isDashboardEnabled,
  isGL,
  isOwnerArchived,
}: {
  isDashboardEnabled: boolean;
  isGL: boolean;
  isOwnerArchived: boolean | undefined;
}) {
  return isDashboardEnabled && isGL && isOwnerArchived === false;
}

export function canShowOwnerPortalReservations({
  hostname,
  isDev,
  showReservations,
}: {
  hostname: string;
  isDev: boolean;
  showReservations: boolean;
}) {
  return showReservations || isDev || hostname === 'localhost';
}

export function getOwnerAccessWhere({
  isImpersonating,
  teamId,
  meId,
}: {
  isImpersonating: boolean;
  teamId: string | null | undefined;
  meId: string | null | undefined;
}): OwnerAccessWhere {
  if (!isImpersonating || !teamId) {
    return {
      userId: { _eq: meId },
    };
  }

  return {
    userId: { _eq: meId },
    _or: [
      {
        contact: {
          tenantId: { _eq: teamId },
        },
      },
      {
        owner: {
          tenantId: { _eq: teamId },
        },
      },
    ],
  };
}
